import grapesjs from "grapesjs";
import { useEffect, useState } from "react";
import { useBodyEditor } from "../../../context/GrapeJsBodyContext";
import { deviceManager } from "./deviceManage";
import { tw } from "@careinfo/tailwind";
import bodyPlugins from "../Plugins/Body/index";
import basicPlugins from "grapesjs-blocks-basic";
import APIS from "../../../constant/Endpoint";
import { useParams } from "react-router-dom";
import useGetHook from "../../../hooks/useGetHook";
import Modal from "../../../shared/Modal";
import Seoform from "../../SeoForm";
import Modalform from "../../Modalform";
import usePatchHook from "../../../hooks/usePatchHook";
import useEditor from "../../../hooks/useEditor";
import { accessToken } from "../../../helpers/sessionKey";
import { API_ROOT } from "../../../helpers/AxiosInstance";
import "grapesjs/dist/css/grapes.min.css";

const BodyEditor = (props: any) => {
  const { editorRef, handleDisable } = props;
  const { setEditor, editor: bodyEditor } = useBodyEditor();
  const [files, setFiles] = useState([]);
  const [isSettingPopup, setIsSettingPopup] = useState(false);
  const [isSeoPopup, setIsSeoPopup] = useState(false);
  const { id } = useParams();
  const { handleMediaUpload } = useEditor();
  const { data: pageData } = useGetHook({
    queryKey: [`page-${id}`],
    url: `${APIS.PAGE}${id}/`,
    params: {},
  });
  const rootColors = {
    "--primary": "#ef4444",
    "--secondary": "#fea9a9",
  };

  const injectRootVariablesIntoCanvas = (editorInstance) => {
    const canvas = editorInstance.Canvas;
    const iframe = canvas.getFrameEl();

    if (iframe) {
      const iframeDocument =
        iframe.contentDocument || iframe.contentWindow.document;
      const style = iframeDocument.createElement("style");
      style.textContent = `
        :root {
          --primary: ${rootColors["--primary"]};
          --secondary: ${rootColors["--secondary"]};
        }
      `;
      iframeDocument.head.appendChild(style);
    }
  };

  const {
    data,
    isLoading: isSeoDataloading,
    refetch,
  } = useGetHook({
    url: APIS.META_TAG,
    params: { page_id: id },
    queryKey: [`meta-tags-${id}`],
  });

  const { data: media } = useGetHook({
    queryKey: [`media-${id}`],
    url: APIS.FILE,
    params: {
      object_id: id,
    },
  });

  useEffect(() => {
    if (Array.isArray(media) && media.length > 0) {
      const files = media?.map((item) => item?.file);
      setFiles(files);
    }
  }, [media]);

  const { mutateAsync, isLoading } = usePatchHook({
    queryKey: ["pages"],
  });

  const handleUpdate = async (values: any, setError: any) => {
    const url = `${APIS.PAGE}${id}/`;
    const formData = {
      popup_pages: values?.popup_pages
        ? values?.popup_pages?.map((item) => item?.value)
        : [],
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 200) {
        setIsSettingPopup(false);
      }
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    if (!editorRef.current) {
      const editorInstance = grapesjs.init({
        container: "#body-container",
        fromElement: true,
        plugins: [basicPlugins, ...bodyPlugins],
        panels: { defaults: [] },
        height: "800px",
        width: "auto",
        deviceManager: deviceManager,
        canvas: {
          styles: [
            "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css",
            "https://cdn.jsdelivr.net/npm/toastify-js/src/toastify.min.css",
            "https://unpkg.com/aos@2.3.1/dist/aos.css",
          ],
          scripts: [
            "https://careinfo-solutions.s3.ap-south-1.amazonaws.com/tailwind/tailwind.min.js",
            "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js",
            "https://unpkg.com/just-validate@latest/dist/just-validate.production.min.js",
            "https://cdn.jsdelivr.net/npm/toastify-js",
            "https://cdn.jsdelivr.net/npm/sweetalert2@11",
            "https://unpkg.com/aos@2.3.1/dist/aos.js",
          ],
        },
        assetManager: {
          assets: files,
          autoAdd: true,
          dropzone: true,
          openAssetsOnDrop: true,
          showUrlInput: true,
          uploadFile: function (ev: any) {
            const files = ev.dataTransfer
              ? ev.dataTransfer.files
              : ev.target.files;
            if (editorRef.current) {
              handleMediaUpload(files, editorInstance);
            }
          },
        },
        storageManager: {
          type: "remote",
          autosave: false,
          autoload: true,
          stepsBeforeSave: 1,
          options: {
            remote: {
              headers: {
                "Content-Type": "application/json",
                Authorization: `JWT ${accessToken()}`,
              },
              urlLoad: `${API_ROOT}${APIS.PAGE}${id}/grapejs_data/`,
            },
          },
        },
        blockManager: {
          appendTo: "#body-blocks",
          blocks: [],
        },
        traitManager: {
          appendTo: "#body-trait",
        },
        styleManager: {
          appendTo: "#body-style",
        },
        selectorManager: {
          appendTo: "#body-selector",
        },
      });
      editorInstance.on("load", () => {
        injectRootVariablesIntoCanvas(editorInstance);
      });
      setEditor(editorInstance);
      editorRef.current = editorInstance;
    }

    return () => {
      if (editorRef.current) {
        editorRef.current.destroy();
        editorRef.current = null;
      }
    };
  }, []);

  bodyEditor?.Commands.add("setting-popup", {
    run(editor, sender, opts) {
      setIsSettingPopup(!isSettingPopup);
    },
  });

  bodyEditor?.Commands.add("seo-popup", {
    run(editor, sender, opts) {
      setIsSeoPopup(!isSeoPopup);
    },
  });

  return (
    <>
      <div
        id="body-container"
        className={tw`my-1 shadow`}
        onMouseEnter={() => handleDisable("body")}
      ></div>
      <Modal title="Seo Menu" isOpen={isSeoPopup} setIsOpen={setIsSeoPopup}>
        <Seoform id={id} setIsOpen={setIsSeoPopup} refetch={refetch} />
      </Modal>
      <Modal
        title="Setting Menu"
        isOpen={isSettingPopup}
        setIsOpen={setIsSettingPopup}
      >
        <Modalform
          handleUpdate={handleUpdate}
          isLoading={isLoading}
          pageData={pageData}
        />
      </Modal>
    </>
  );
};

export default BodyEditor;
